import { List } from '@chakra-ui/react';
import { IBillGroupResp, IQuoteRespSchema } from '@monetize/types/app';
import { useAtom } from 'jotai';
import { MText, MUnorderedList } from '../../../../components/Monetize';
import { QuoteBannerItem } from './QuoteBannerItem';
import { bannerDismissedSelector, checkUsageDate } from './quoteBanner.utils';

const BannerContent = ({ bannerTextList }: { bannerTextList: string[] }) => {
  if (bannerTextList.length === 0) {
    return null;
  }

  if (bannerTextList.length === 1) {
    return <MText>{bannerTextList[0]}</MText>;
  }

  return (
    <MUnorderedList>
      {bannerTextList.map((bannerText) => (
        <List.Item key={bannerText}>
          <MText>{bannerText}</MText>
        </List.Item>
      ))}
    </MUnorderedList>
  );
};

export function UsageProductBanner({
  quote,
  billGroup,
}: {
  quote: IQuoteRespSchema;
  billGroup: IBillGroupResp;
}) {
  const [dismissed, setDismissed] = useAtom(
    bannerDismissedSelector([quote.id, 'UsageProductWarningBanner']),
  );
  const bannerTextList = checkUsageDate(quote, billGroup);

  if (dismissed || !bannerTextList.length) {
    return null;
  }

  return (
    <QuoteBannerItem onDismiss={() => setDismissed(true)} type="warning">
      <BannerContent bannerTextList={bannerTextList} />
    </QuoteBannerItem>
  );
}
